import React from 'react';
import { ConversationProvider } from './ConversationProvider';
import { MessageProvider } from './MessageProvider';
import { UserPresenceProvider } from './UserPresenceProvider';
import { UIStateProvider } from './UIStateProvider';


/**
 * ChatProviders - Composition Root for All Chat Contexts
 *
 * This component wraps all chat-related providers for convenient usage.
 * Providers are composed in a specific order to manage dependencies:
 *
 * 1. ConversationProvider - No dependencies
 * 2. MessageProvider - Depends on conversation data (for activeConversationId)
 * 3. UserPresenceProvider - Depends on conversations (for member lists)
 * 4. UIStateProvider - No external dependencies
 *
 * Note: The legacy ChatProvider has been removed. All components should use
 * the new modular contexts: useConversation, useMessages, usePresence, useUIState
 */
export const ChatProviders = ({ children }) => {
  return (
    <ConversationProvider>
      <MessageProvider>
        <UserPresenceProvider>
          <UIStateProvider>
            {children}
          </UIStateProvider>
        </UserPresenceProvider>
      </MessageProvider>
    </ConversationProvider>
  );
};

export default ChatProviders;
